import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import { ApprovalEditorButtons } from 'ui-product-approvals/components/consumer/ApprovalEditorButtons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getNumErrorsAndWarnings = ({
  errorsAndWarnings,
  errorsAndWarningsAndInfosCount
}) => {
  if (errorsAndWarningsAndInfosCount) {
    return errorsAndWarningsAndInfosCount;
  }
  if (errorsAndWarnings) {
    return errorsAndWarnings.length;
  }
  return 0;
};
const EditorApprovalButtons = ({
  children,
  isTestVariation,
  testVariationDisabledTooltip,
  onOpenWarningsAndSuggestionsPanel,
  errorsAndWarnings,
  errorsAndWarningsAndInfosCount,
  extraActionButtons,
  dropdownProps,
  buttonSize
}) => {
  const numCount = getNumErrorsAndWarnings({
    errorsAndWarnings,
    errorsAndWarningsAndInfosCount
  });
  const additionalDropdownButtons = [...(extraActionButtons ? extraActionButtons.map(({
    label,
    onClick,
    id
  }) => /*#__PURE__*/_jsx(Button, {
    "data-test-id": id,
    onClick: onClick,
    children: label
  }, id)) : []), /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "editor-approval-warnings-button",
    onClick: onOpenWarningsAndSuggestionsPanel,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "approvals.warningsAndSuggestions"
    }), numCount > 0 && /*#__PURE__*/_jsx(Badge, {
      use: "count",
      children: numCount
    })]
  }, "warnings")];
  return /*#__PURE__*/_jsx(ApprovalEditorButtons, {
    approvalOperationDisabledReason: isTestVariation ? testVariationDisabledTooltip !== null && testVariationDisabledTooltip !== void 0 ? testVariationDisabledTooltip : true : undefined,
    additionalDropdownButtons: additionalDropdownButtons,
    dropdownProps: dropdownProps,
    size: buttonSize,
    children: children
  });
};
export default EditorApprovalButtons;